import type { Ranges } from 'api/System/types'
import { getDateKey } from 'data/utils'
import { moment } from 'locale'
import type { Action } from 'redux'
import type { RequestDate } from 'types/UI'
import { emptyObject, parseDateForRequest } from 'utils'

import { FETCH_OMS_ORIGIN, FETCH_OMS_ORIGIN_DONE, FETCH_OMS_ORIGIN_ERROR, FETCH_OMS_ORIGIN_SUCCESS } from './constants'
import type { OmsOrigin, OmsOrigins as OmsOriginsState } from './types'

interface ReducerAction extends Action {
  payload: {
    data: OmsOrigin[]
    dateCurrent: RequestDate
    dateCompared?: RequestDate | null
    errorCode?: number
    range: Ranges
  }
}

export default function OmsOrigins(state: OmsOriginsState = emptyObject, { payload, type }: ReducerAction) {
  switch (type) {
    case FETCH_OMS_ORIGIN:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          errorCode: null,
          isLoading: true,
        },
      }
    case FETCH_OMS_ORIGIN_DONE:
      return {
        ...state,
        [getDateKey(payload)]: {
          ...(state[getDateKey(payload)] || emptyObject),
          isLoading: false,
        },
      }
    case FETCH_OMS_ORIGIN_ERROR:
      return {
        ...state,
        [getDateKey(payload)]: {
          errorCode: payload?.errorCode,
          isLoading: false,
        },
      }
    case FETCH_OMS_ORIGIN_SUCCESS:
      return {
        ...state,
        [getDateKey(payload)]: {
          data: payload.data,
          fetchTime: parseDateForRequest(moment(), true),
          isLoading: false,
        },
      }
    default:
      return state
  }
}
